import { render } from "./FeaturedImage.vue?vue&type=template&id=277656b4&scoped=true&ts=true"
import script from "./FeaturedImage.vue?vue&type=script&lang=ts"
export * from "./FeaturedImage.vue?vue&type=script&lang=ts"

import "./FeaturedImage.vue?vue&type=style&index=0&id=277656b4&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277656b4"]])

export default __exports__